module.exports = __webpack_public_path__ + "pdf/materials.3e0a6a4.pdf";